<div id="orderCompletedContent" [ngClass]="{'mobile': isMobile}">
  <ds-paper class="dark-border paper-position" elevation="elevation_none" borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_L" 
    insidePaddingBottom="bottom-spacing_L" insidePaddingLeft="left-spacing_L" insidePaddingRight="right-spacing_L">
    <div class="content">
      <div id="orderCompletedMessageContainer" class="text-container">
        <typography variant="mat-headline-4" weight="bold">{{ appStrings.order_completedMessage }}</typography>
      </div>
      <div id="orderCompletedMessageContainer" class="text-container">
        <typography variant="mat-subtitle-1" weight="medium">{{ appStrings.order_completedThankMessage }}</typography>
      </div>

      <div id="orderCompletedMessageContainer" class="text-container">
        <typography variant="mat-caption-1" weight="regular" class="grey">{{ appStrings.order_confirmationNumber }}</typography>
      </div>
      <div id="orderCompletedMessageContainer" class="text-container">
        <typography variant="mat-subtitle-1" weight="bold">{{ orderConfirmationNumber }}</typography>
      </div>

      <div id="printExportOrderButtonsContainer" class="printExport-buttonsContainer">
        <ds-button size="medium" type="primary" variant="label-only" [label]="appStrings.button_goToQuotes" id="goToQuotesButton" (onClick)="goToQuotes()">
        </ds-button>
      </div>

      <div class="divider"><ds-divider></ds-divider></div>

      <div id="printExportEmailOrderContainer" class="print-export-email-order-container">
        <div id="orderCompletedMessageContainer" class="text-container">
          <typography variant="mat-caption-1" weight="regular" class="grey">{{ appStrings.order_printExportEmailOptionsLabel }}</typography>
        </div>
        <div id="printExportOrderButtonsContainer" class="printExport-buttonsContainer">
          <ds-button size="medium" type="secondary" variant="label-icon" icon="print" [label]="appStrings.button_print" id="printOrderButton"
            iconPosition="left" iconStyle="material-icons-outlined" (onClick)="printOrder()">
          </ds-button>
          <ds-button size="medium" type="secondary" variant="label-icon" icon="description" [label]="appStrings.button_export" id="exportOrderbutton"
            iconPosition="left" iconStyle="material-icons-outlined" (onClick)="exportOrder()">
          </ds-button>
          <ds-button size="medium" type="secondary" variant="label-icon" icon="mail" [label]="appStrings.button_email" id="emailOrderbutton"
            iconPosition="left" iconStyle="material-icons-outlined" (onClick)="emailOrder()">
          </ds-button>
        </div>
      </div>
    </div>
  </ds-paper>
</div>